import React, { Component } from "react";
import { ModalBody, ModalFooter, Button, FormGroup, Label, Input } from "reactstrap";
import CustomModal from "./index";

class OTPVerificationModal extends Component {
	state = {
		otp: "",
	};

	handleKeyPress = (e) => {
		if (e.key === "Enter" && this.state.otp.length === 6) {
			this.props.onVerify(this.state.otp);
		}
	};

	handleChange = (e) => {
		const value = e.target.value;
		// Only allow numbers and max 6 digits
		if (/^\d{0,6}$/.test(value)) {
			this.setState({ otp: value });
		}
	};

	handleVerify = () => {
		this.props.onVerify(this.state.otp);
		this.setState({ otp: "" }); // Clear OTP after verification
	};

	handleResend = () => {
		this.setState({ otp: "" }); // Clear OTP when resending
		this.props.onResend();
	};

	componentDidUpdate(prevProps) {
		// Clear OTP when modal is opened
		if (!prevProps.isOpen && this.props.isOpen) {
			this.setState({ otp: "" });
		}
	}

	render() {
		const { isOpen, onClose, loading, error, email } = this.props;
		const { otp } = this.state;

		return (
			<CustomModal
				isOpen={isOpen}
				title="OTP Verification"
				onClose={onClose}
				size="md">
				<ModalBody>
					<p>
						A 6-digit verification code has been sent to <strong>{email}</strong>
					</p>
					{error && (
						<p style={{ color: "#ff0000", marginBottom: 10 }}>
							{error}
						</p>
					)}
					<FormGroup>
						<Label for="otpInput">Enter OTP Code</Label>
						<Input
							type="text"
							name="otp"
							id="otpInput"
							placeholder="Enter 6-digit code"
							value={otp}
							onChange={this.handleChange}
							onKeyPress={this.handleKeyPress}
							disabled={loading}
							maxLength={6}
							style={{
								fontSize: "24px",
								textAlign: "center",
								letterSpacing: "8px",
							}}
							autoFocus
						/>
					</FormGroup>
					<div style={{ textAlign: "center", marginTop: 20 }}>
						<Button
							color="link"
							onClick={this.handleResend}
							disabled={loading}>
							Didn't receive the code? Resend
						</Button>
					</div>
				</ModalBody>
				<ModalFooter>
					<Button
						color="secondary"
						onClick={onClose}
						disabled={loading}>
						Cancel
					</Button>
					<Button
						color="primary"
						onClick={this.handleVerify}
						disabled={loading || otp.length !== 6}>
						{loading ? "Verifying..." : "Verify"}
					</Button>
				</ModalFooter>
			</CustomModal>
		);
	}
}

export default OTPVerificationModal;
